import { css } from '@emotion/core';
export var intrinsic = {
  name: "1nrwzd5",
  styles: "margin:0;padding:0 0 56.25% 0;position:relative;width:100%;"
};
export var iframe = {
  name: "1ymouwi",
  styles: "border:0;bottom:0;height:100%;left:0;position:absolute;right:0;top:0;width:100%;"
};